import GoTrue from "gotrue-js";

const authInstance = new GoTrue({
	APIUrl: "https://newarkhouserentaldev.netlify.app/.netlify/identity",
	setCookie: true,
	loginExternalUrl: "/.netlify/identity",
	acceptInviteExternalUrl: "/.netlify/identity",
});

export default {
	// Email + password: Signup
	signup: (email, password, metadata) => {
		// console.log("Attempting signup", { email, metadata });
		return authInstance.signup(email, password, metadata)
			.then((response) => {
				// console.log("Signup successful", response);
				return response;
			})
			.catch((error) => {
				console.error("Signup failed", error);
				throw error;
			});
	},

	// Email + password: Login (updated to include the remember parameter)
	login: (email, password, remember) => {
		// console.log("Attempting login", { email, remember });
		return authInstance.login(email, password, remember)
			.then((response) => {
				// console.log("Login successful", response);
				return response;
			})
			.catch((error) => {
				console.error("Login failed", error);
				throw error;
			});
	},

	// Social / OAuth: Signup or login with provider.
	signupWithProvider: (provider) => {
		// console.log("Attempting OAuth login with provider", provider, authInstance);
		return authInstance.loginWithOAuth({
			provider,
			redirectTo: window.location.origin,
		});
	},

	// Get the current user (or null)
	currentUser: () => {
		const user = authInstance.currentUser();
		// console.log("Current user:", user);
		return user;
	},

	// Logout
	logout: () => {
		const user = authInstance.currentUser();
		if (user) {
			// console.log("Logging out user", user);
			return user.logout();
		} else {
			console.warn("Logout called but no user is logged in.");
			return Promise.resolve();
		}
	},

	// Request password recovery email
	resetPassword: async (email) => {
		try {
			// Point to your dedicated reset password page.
			const redirectTo = "https://newarkhouserentaldev.netlify.app/reset-password";
			// console.log("Requesting password recovery email for:", email, "Redirect URL:", redirectTo);

			const response = await authInstance.requestPasswordRecovery(email, { redirectTo });
			// console.log("Recovery email sent successfully", response);
			return response;
		} catch (error) {
			console.error("Error requesting password recovery", error);
			throw error;
		}
	},

	// Complete the password reset by providing the recovery token and a new password.
	completePasswordReset: (recoveryToken, newPassword) => {
		// console.log("Completing password reset", { recoveryToken, newPassword: "*****" });
		return authInstance.recover(recoveryToken, newPassword)
			.then((response) => {
				// console.log("Password reset successful", response);
				const user = authInstance.currentUser();
				if (user) {
					// console.log("user", user)
					user.update({ password: newPassword })
						.then((response) => {
							return response;
							// console.log("Password reset and updated successfully", response);
							// Optionally clear session, force logout, or prompt user to re-login.
						})
						.catch((error) => {
							console.error("Error updating password after recovery", error);
						});
				}
				return response;
			})
			.catch((error) => {
				console.error("Error completing password reset", error);
				throw error;
			});
	},

	// Update current user profile
	// Pass an object with updated user metadata, for example { first_name: "New", last_name: "Name" }
	updateProfile: (updates) => {
		const user = authInstance.currentUser();
		if (user) {
			// console.log("Updating profile with", updates);
			return user.update(updates)
				.then((response) => {
					// console.log("Profile update successful", response);
					return response;
				})
				.catch((error) => {
					console.error("Profile update failed", error);
					throw error;
				});
		} else {
			console.warn("No current user to update.");
			return Promise.reject("No current user found");
		}
	},

	// Optionally, if you need to get the current access token
	getAccessToken: () => {
		const user = authInstance.currentUser();
		// console.log("Getting access token for user:", user);
		return user ? user.token : null;
	},
	// --- External/OAuth flows (NEW) ---

	/** Redirects the browser to the OAuth login page for `provider`. */
	// loginWithProvider: (provider) => {
	// 	const url = authInstance.loginExternalUrl(provider);
	// 	if (!url) throw new Error(`No login URL for provider "${provider}"`);
	// 	window.location.href = url;
	// },
	loginWithProvider: (provider) => {
		let url = null;

		switch (provider) {
			case "google":
			case "github":
			case "gitlab":
				// Use Netlify Identity built-in
				url = authInstance.loginExternalUrl(provider);
				break;

			case "twitter":
				// Custom OAuth flow for Twitter via Netlify Function
				url = "/.netlify/functions/twitter-login";
				break;

			case "facebook":
				// Custom OAuth flow for Facebook via Netlify Function
				url = "/.netlify/functions/facebook-login";
				break;

			default:
				throw new Error(`Unsupported provider "${provider}"`);
		}

		if (!url) {
			throw new Error(`No login URL configured for provider "${provider}"`);
		}

		window.location.href = url;
	},

	/**
	 * Redirects the browser to the accept‑invite page for `provider`+`token`.
	 * Used when someone lands with ?invite_token=... in the URL.
	 */
	acceptInviteWithProvider: (provider, inviteToken) => {
		const url = authInstance.acceptInviteExternalUrl(provider, inviteToken);
		if (!url)
			throw new Error(
				`No invite‑accept URL for provider "${provider}", token "${inviteToken}"`
			);
		window.location.href = url;
	},
	// --- Re-export GoTrue events so you can do auth.on("init", ...) in AuthContext ---
	on: typeof authInstance.on === "function" ? authInstance.on.bind(authInstance) : () => { },
	off: typeof authInstance.off === "function" ? authInstance.off.bind(authInstance) : () => { },
};

export function handleOAuthError() {
	if (typeof window === "undefined") return;
	const hash = window.location.hash.slice(1);
	const params = new URLSearchParams(hash);
	if (params.has("error_description")) {
		throw new Error(decodeURIComponent(params.get("error_description")));
	}
}
